export const HOME_LICENSES_STRINGS = {
  title: "Let's confirm your DC registration and licenses.",
  subtitle:
    'Washington DC requires every rental home to be registered with the Rental Accommodations Division (RAD) and to hold a Basic Business License. We need these details before your home can be listed — and DC law requires them before any lease can be enforced.',

  // Year built
  'year_built.title': 'When was your home built?',
  'year_built.subtitle':
    'This determines which DC lead requirements apply to your home.',
  'year_built.label': 'Year Built (YYYY)',

  // RAD status
  'rad.title':
    'Is your home registered with the DC Rental Accommodations Division?',
  'rad.subtitle':
    "You'd have received a date-stamped RAD Form 1 with a registration or exemption number.",
  'rad.most_common': 'Most Common',
  'rad.exempt_label': 'Registered | Exempt',
  // The only label long enough to reflow once the selected state bolds it, so
  // `StabilizedLabel` stacks it from `lg` up — hence the copy stored per line.
  'rad.stabilized_line_1': 'Registered |',
  'rad.stabilized_line_2': 'Rent Stabilized',
  'rad.none_label': 'Not yet registered',

  'rad.registration_number_label': 'RAD Registration Number',
  'rad.stabilized_info':
    "Because this home is rent stabilized, we'll also ask about rent history and any surcharges below.",

  'rad.exemption_number_label': 'RAD Exemption Number',
  'rad.exemption_reason_label':
    'Why is your home exempt from rent stabilization?',
  'rad.exemption_small_landlord_label': 'Small Landlord (C)',
  'rad.exemption_small_landlord_sublabel':
    'You and any co-owners are individuals who own 4 or fewer DC rental units in total',
  'rad.exemption_new_construction_label': 'New Construction (B)',
  'rad.exemption_new_construction_sublabel':
    'Building permit issued after Dec 31, 1975',
  'rad.exemption_government_label': 'Government-Owned or Subsidized (A)',
  'rad.exemption_government_sublabel':
    'Federal or District ownership, or subsidized mortgage/rent',
  'rad.exemption_cooperative_label': 'Cooperative Unit (E)',
  'rad.exemption_cooperative_sublabel':
    'Owned by a co-op association; 4 or fewer individual owners with 4 or fewer DC units',
  'rad.exemption_other_label': 'Other (D · F · G)',
  'rad.exemption_other_sublabel':
    'Continuously vacant in statutory window · Building Improvement Plan · DHCD assistance',

  'rad.form_upload_label': 'RAD Form 1',
  'rad.none_warning':
    "Your home can't be listed until it's registered. DC requires filing a Registration or Claim of Exemption (RAD Form 1) with DHCD within 30 days of offering a home for rent, and doesn't allow a notice to vacate or eviction filing for an unregistered home. File with the Rental Accommodations Division (dhcd.rad@dc.gov, (202) 442-9505), then come back and upload your date-stamped copy. Most individual owners qualify for the small-landlord exemption.",

  // Shown as a toast when the homeowner tries to advance while unregistered; the
  // red warning above is the on-page explanation, so keep this to one line.
  'rad.none_error':
    'Your home must be registered with RAD before you can continue.',

  // Basic Business License
  'bbl.title': 'Please provide your Basic Business License details.',
  'bbl.subtitle':
    'This would have been issued by the Department of Licensing and Consumer Protection, and obtained prior to registering with RAD.',
  'bbl.number_label': 'License Number',
  'bbl.name_label': 'Name On License',
  'bbl.expiration_label': 'Expiration Date (MM/DD/YYYY)',
  'bbl.upload_label': 'License',

  // Certificate of Occupancy
  'cofo.title': 'Certificate of Occupancy',
  'cofo.subtitle': 'Required for properties with two or more units.',
  'cofo.number_label': 'C of O Number',
  'cofo.number_placeholder': 'e.g. CO1234567',
  'cofo.issuance_label': 'Issuance date',
  'cofo.upload_label': 'Certificate',

  // DC Water lead service line
  'dc_water.title':
    'According to the DC Water website (dcwater.com/leadmap), what is the information listed for the lead water service line at this property?',
  'dc_water.subtitle': 'Required for DC homes built before 1986.',
  'dc_water.private_type_label': 'Private Type',
  'dc_water.private_description_label': 'Private Description',
  'dc_water.public_type_label': 'Public Type',
  'dc_water.public_description_label': 'Public Description',

  // Rent history
  'rent_history.title': 'Rent History — Last 3 Years',
  'rent_history.subtitle':
    'DC requires disclosing every rent adjustment in the past 3 years, with the section of the Rental Housing Act that allowed it. We regenerate this as RAD Form 4 and deliver it with the lease.',
  'rent_history.year_placeholder': 'Year',
  'rent_history.prior_rent_placeholder': 'Prior Rent',
  'rent_history.new_rent_placeholder': 'New Rent',
  'rent_history.effective_placeholder': 'Effective Date (MM/DD/YYYY)',
  'rent_history.basis_placeholder': 'Basis (Section of Act)',
  'rent_history.comparable_unit_placeholder': 'Comparable Unit #',
  'rent_history.comparable_unit_helper':
    'Only when the basis is 213(a)(2): the substantially identical unit used for the comparable vacancy increase.',
  'rent_history.add_row': 'Add Adjustment',

  // Shown as a toast when a rent-stabilized home has disclosed no adjustment at
  // all; keep it to one line.
  'rent_history.min_rows_error': 'Please provide at least one rent adjustment.',
};
